import React from "react";
import Icons from "../../../components/util/Icons";

const CSS = {
    capacityWarning: "i-modal-capacity-warning"
}

export default class Warning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        message: null
    }
  }

  componentDidMount () {
    if (typeof this.props._onMount === "function") {
      this.props._onMount(this);
    }
  }

  setMessage(message) {
      this.setState({
          message: message
      })
  }

  render() {
    return this.state.message ? (
      <div className={CSS.capacityWarning}>
        {Icons.exclamationTriangle16()}
        {this.state.message}
      </div>
    ) : this.props.message ? (
      <div className={CSS.capacityWarning}>
        {Icons.exclamationTriangle16()}
        {this.props.message}
      </div>
    ) : null;
  }

}
